import { handleServerErrors, Result } from 'core/infrastructure';
import { getDocumentIdByGlobalId } from 'pos/facades/RestaurantFacade';

export enum EntityType {
	Ticket = 10,
	DeliveryNote = 11,
	Invoice = 12,
	Cancellation = 13,
	SalesOrder = 14
}

const SEED = 93515433;

export function encodeId(entity: EntityType, id: number): string {
	if (id >= 9999999)
		throw Error(`El Id ${id} es demasiado grande para poder generar un código de barras`);

	// Convertimos a un int32 con  " xxx | 0" como en el PC. Si no, al no tener desbordamiento, no se comporta como el PC y la lectura de códigos
	// da otros valores. https://stackoverflow.com/questions/67514893/javascript-parseinteger-to-int32
	const str = ((entity * SEED + id * SEED + SEED) | 0).toString();
	const crc = str.substring(str.length - 3);

	const encode = entity.toString().padStart(2, '0') + id.toString().padStart(7, '0') + crc;
	return encode;
}

export async function tryDecodeId(entity: EntityType, barcode: string): Promise<Result<number>> {
	if (barcode.length < 12)
		return Result.error();

	if (isQRCode(barcode)) {
		let errorMessage = '';
		const globalIdResult = await handleServerErrors(async () => await getDocumentIdByGlobalId(barcode, entity), {
			onTicketNotFoundError: async (e) => {
				errorMessage = e.message;
			}
		});

		return globalIdResult.ok ? globalIdResult : Result.error(errorMessage);

	}

	const id = +(barcode.substring(2, 9));

	if (Number.isNaN(id))
		return Result.error();

	// Uso StartsWith para permitir ignorar el dígito de control del EAN13 si lo manda el Scanner
	return barcode.startsWith(encodeId(entity, id)) ? Result.ok(id) : Result.error();
}

export function isQRCode(code: string): boolean {
	return code.length === 36 && /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/.test(code);
}